import { getUserInfo } from '@/api/user'
const state = {
  userInfo: null
}

const getters = {
  isSuperAdmin: state => {
    return state.userInfo.roles.includes('SUPER_ADMIN')
  }
}

const mutations = {
  SET_USERINFO (state, userInfo) {
    state.userInfo = {...state.userInfo, ...userInfo}
  }
}

const actions = {
  async GET_USERINFO ({ commit }) {
    const userInfo = await getUserInfo()
    commit('SET_USERINFO', userInfo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}